import authRules from '../authRules.js';

const changeAbsencesResource = (user) => {
  const { changeAbsencesResource } = user.securityLevels;
  if (changeAbsencesResource >= authRules.changeAbsencesResource.changeAbsencesResource) {
      return true;
  } else {
      return false;
    }
  }


export default changeAbsencesResource;
